module.exports = __webpack_public_path__ + "img/down-from-line.9b822859.svg";